import { StyleSheet } from 'react-native';
import { SEMANTIC_COLORS, COMPONENT_COLORS, PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

export const CORK_BOARD_COLORS = {
  cardBackground: COMPONENT_COLORS.card.background,
  cardBorder: COMPONENT_COLORS.card.border,
  announcementBorder: '#1D4ED8',
  announcementBg: 'rgba(29, 78, 216, 0.08)',
  pinIcon: '#F59E0B',
  lockIcon: SEMANTIC_COLORS.text.tertiary,
  defaultTagColor: '#6B7280',
  tagTextActive: '#FFFFFF',
  searchBackground: PRIMITIVE_COLORS.gray850,
  skeletonBase: PRIMITIVE_COLORS.gray850,
  skeletonHighlight: PRIMITIVE_COLORS.gray700,
} as const;

export const corkBoardStyles = StyleSheet.create({
  screenContainer: {
    flex: 1,
    backgroundColor: SEMANTIC_COLORS.background.primary,
  },
  feedContentContainer: {
    paddingBottom: 40,
  },
  sectionPadding: {
    paddingHorizontal: 16,
  },
  card: {
    backgroundColor: CORK_BOARD_COLORS.cardBackground,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: CORK_BOARD_COLORS.cardBorder,
    padding: 16,
    gap: 10,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textPrimary: {
    color: SEMANTIC_COLORS.text.primary,
  },
  textSecondary: {
    color: SEMANTIC_COLORS.text.secondary,
  },
  textMuted: {
    color: SEMANTIC_COLORS.text.muted,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: COMPONENT_COLORS.avatar.background,
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarText: {
    fontSize: 11,
    fontWeight: '600',
    color: COMPONENT_COLORS.avatar.text,
  },
});
